module.exports = __webpack_public_path__ + "static/img/GPTLOGO.6b41eb25.png";